import ShopProListPC from "./ShopProListPC"

export default function ShopModuleProductList(props) {
  return (
    <div className="product-list-wrap">
      <ShopProListPC {...props} isSearchPage={false} />
      <style jsx>{`
        .product-list-wrap {
          background-color: #fff;
        }
      `}</style>
    </div>
  )
}
